module.exports = __webpack_public_path__ + "static/jan_4-ee17dca80aec55e4fc81d8a1a22d07dc.mp4";